<template>
  <div class="Password-container">
    <div class="allClass">
      <div class="titleClass"><b>重置邮箱账号登录密码</b></div>

      <el-form :rules="ruleList" :model="user" ref="userForm"><!--用来校验表单-->

        <el-form-item prop="name"><!--必须el-form-item prop="xxx"才能生效-->
          <el-input placeholder="请输入您的邮箱" size="medium" class="inputOneClass" prefix-icon="el-icon-message"
                    v-model="user.name" autocomplete="new-password"></el-input>
        </el-form-item>

        <el-form-item prop="code"><!--邮箱获取的验证码，放置非法注册-->
          <el-input placeholder="邮箱收到的验证码" size="medium" class="inputOneClass" prefix-icon="el-icon-lock"
                    v-model="user.code" style="width: 188px;"></el-input>
          <el-button type="primary" size="medium" class="ml-10" @click="getEmailCode">获取验证码</el-button>
        </el-form-item>

        <el-form-item prop="password">
          <el-input placeholder="请设置重置密码" size="medium" class="inputOneClass" prefix-icon="el-icon-lock"
                    v-model="user.password"
                    show-password autocomplete="new-password"></el-input>
        </el-form-item>


        <div class="buttonClass">
          <el-button type="primary" size="medium" autocomplete="off" @click="registerClick">重置密码</el-button>
          <el-button type="warning" size="medium" autocomplete="off" @click="$router.push('/login')">返回登录
          </el-button>
        </div>
      </el-form>

    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      user: {},
      ruleList: { // 在return的第一级别写
        name: [
          {required: true, message: '请输入您的邮箱账号', trigger: 'blur'},
          {min: 3, max: 20, message: '长度在3-9个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请设置重置密码', trigger: 'blur'},
          {min: 3, max: 20, message: '长度在3-20个字符', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入收到的验证码', trigger: 'blur'},
          {min: 3, max: 20, message: '长度在3-20个字符', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    getEmailCode() {
      if (!this.user.name) {
        this.$message.warning("请输入邮箱账号")
        return
      }
      if (!/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(this.user.name)) {
        this.$message.warning("请输入正确的邮箱账号")
        return
      }
      // 都通过请求发送邮箱验证码---name的值其实就是用户邮箱
      this.$http.post("/big/email_code", this.user).then(res => {
        if (res.data.code === "200") {
          this.$message.success("邮箱验证码发送成功，请到对应邮箱查看")
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /*点击登录*/
    registerClick() {
      this.$refs["userForm"].validate(valid => {
        if (valid) { // 表单校验合法
          this.$http.post("/big/reset_password", this.user).then(res => { // 调用后端注册方法
            // console.log(res.data)
            if (res.data.code === "200") {
              this.$router.push("/login")
              this.$message.success("重置密码成功，请登录！")
            } else {
              this.$message.error(res.data.message)
            }
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.Password-container {
  height: 100vh;
  background-image: linear-gradient(to bottom right, deepskyblue, darkcyan);
  overflow: hidden;
}

.allClass {
  margin: 200px auto;
  background-color: #ffffff;
  width: 350px;
  height: 400px;
  padding: 20px;
  border-radius: 10px;
}

.titleClass {
  margin: 20px 0;
  text-align: center;
  font-size: 24px;
}

.inputOneClass {
  margin: 10px 0;
}

.buttonClass {
  margin: 10px 0;
  text-align: right;
}
</style>
